export default __webpack_public_path__ + "static/media/wapowski.f44c089b.png";